// @ts-check
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DomainIcon from '@material-ui/icons/Domain';
import CostsIcon from '@material-ui/icons/MonetizationOn';
import Tooltip from '@material-ui/core/Tooltip'
import Icon from '@material-ui/core/Icon';
import PlootoTabLogo from '../../assets/logo.png';
import Divider from '@material-ui/core/Divider';
import HelpIcon from '@material-ui/icons/Help';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import {
  SET_ACTIVE_TAB,
  SET_FORM_OPEN
} from '../../redux/actions/actionTypes'

const useStyles = makeStyles((theme) => ({
  tabsContainerWrapper: {
    display: "inline-block",
    verticalAlign: "top",
    width: "50px",
    height: "100%",
    borderRight: `2px solid ${theme.palette.divider}`
  },
  tabsContainer: {
    display: "flex",
    flexDirection: "column"
  },
  tabLogo: {
    width: theme.spacing(6),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  tabs: {
    width: theme.spacing(6),
    flexGrow: 1
  },
  h100: {
    height: "100%"
  }
}));

const TabButton = withStyles((theme) => ({
  root: {
    width: theme.spacing(6),
    minWidth: theme.spacing(6),
    maxWidth: theme.spacing(6),
    color: theme.palette.grey["400"],
    '&$selected': {
      color: "#000000"
    }
  },
  selected: {}
}))(Tab);

function SiteTabsContainer() {
  const styles = useStyles();
  const dispatch = useDispatch()
  const topLevelState = useSelector(state => state.topLevel);

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={styles.tabsContainerWrapper}
    >
      <div className={styles.tabsContainer}>
        {/* Logo then divider */}
        <img src={PlootoTabLogo} className={styles.tabLogo} alt="Plooto logo" />
        <Divider />

        {/* Tabs */}
        <Tabs
          orientation="vertical"
          value={topLevelState.active_tab}
          onChange={(event, newValue) => {
            dispatch({
              type: SET_ACTIVE_TAB,
              payload: newValue
            })
            dispatch({
              type: SET_FORM_OPEN,
              payload: true
            })
          }}
          className={styles.tabs}
          textColor="primary"
          TabIndicatorProps={{
            style: {
              display: "none"
            }
          }}
          classes={{
            // @ts-ignore
            flexContainerVertical: styles.h100
          }}
        >

          <Tooltip placement="bottom" title="Building Info">
            <TabButton icon={<DomainIcon />} />
          </Tooltip>

          <Tooltip placement="bottom" title="Costs">
            <TabButton icon={<CostsIcon />} />
          </Tooltip>

          <Tooltip placement="bottom" title="Sustainability performace">
            <TabButton icon={<Icon className="fas fa-universal-access" />} />
          </Tooltip>

          {/* Bottom left icons */}
          {/* <Tooltip placement="bottom" title="Help">
            <TabButton style={{ marginTop: "auto" }} icon={<HelpIcon />} />
          </Tooltip>

          <Tooltip placement="bottom" title="Contact us">
            <TabButton icon={<ContactMailIcon />} />
          </Tooltip> */}

        </Tabs>
      </div>


    </div>

  )
}

export default SiteTabsContainer;